
import { CheckCircle, Circle } from 'lucide-react';

interface StepProgressProps {
  currentStep: number;
}

export function StepProgress({ currentStep }: StepProgressProps) {
  const steps = [
    { id: 1, label: 'ข้อมูลส่วนตัว' },
    { id: 2, label: 'วิชาที่สอน' },
    { id: 3, label: 'ช่วงเวลารับสอน' }
  ];

  return (
    <div className="flex items-center justify-center space-x-2 mb-6 overflow-x-auto">
      {steps.map((step, index) => (
        <div key={step.id} className="flex items-center space-x-2 min-w-fit">
          {currentStep >= step.id ? (
            <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" />
          ) : (
            <Circle className="w-5 h-5 text-gray-400 flex-shrink-0" />
          )}
          <span className={`text-xs sm:text-sm font-medium ${
            currentStep >= step.id ? 'text-green-600' : 'text-gray-400'
          }`}>
            {step.label}
          </span>
          {index < steps.length - 1 && (
            <div className="w-4 sm:w-8 h-px bg-gray-300 flex-shrink-0"></div>
          )}
        </div>
      ))}
    </div>
  );
}
